import { SiteRole } from "../../../types/blastDtos";
import { UserDto } from "../../../types/dto";
import { getBlast, isMockMode, simulateDelay } from "../../api";

interface SiteUserAndRoleDto {
	user: UserDto;
	role: SiteRole;
	email?: string;
}

interface GetUsersBySiteIdResponse {
	users: SiteUserAndRoleDto[];
}

const mapUserEmails = (data: any) => {
	data.users.map((user: any) => (user.email = user.user.email));
	return data;
};

export const getUsersBySiteId = ({ siteId }: { siteId: string }) => {
	if (isMockMode()) {
		const testData = {
			users: [
				{
					user: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					role: 0,
				},
			],
		};
		return simulateDelay(50, () => testData).then(
			mapUserEmails
		) as Promise<GetUsersBySiteIdResponse>;
	}

	return getBlast(`users/getUsersBySiteid?siteId=${siteId}`).then(
		mapUserEmails
	) as Promise<GetUsersBySiteIdResponse>;
};
